<progress [value]="value" [max]="max"></progress>
